import { createFileRoute } from "@tanstack/react-router";
import { MellanoLisToLsbConverterView } from "src/tenantCustomizations/tenants/mellano/views/lisToLsb/MellanoLisToLsbConverterView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/lisToLsb")({
	staticData: { title: "Poran tiedostomuunnos", legacyViewKey: "mellanoLisToLsbConverterView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLisToLsbConverterView />;
}
